import {
  useMutation,
  type MutationFunctionOptions,
  type FetchResult,
} from '@apollo/react-hooks';
import { CREATE_NOMINATION } from './CREATE_NOMINATION.gql';

export const useCreateNomination = (
  refetchGetNomination?: () => void,
): ((options?: MutationFunctionOptions) => Promise<FetchResult>) => {
  const [createNomination] = useMutation(CREATE_NOMINATION, {
    onCompleted: () => {
      if (refetchGetNomination !== undefined) refetchGetNomination();
    },
  });
  return createNomination;
};
